export enum UserStatusEnum {
  ACTIVE = 'active',
  DISABLED = 'disabled'
}
